import styled from 'styled-components';

/** Tabular figures so digits line up column-wise, plus the reserved closing-paren gutter. */
export const AmountCell = styled.div`
	display: flex;
	justify-content: flex-end;
	width: 100%;
	font-variant-numeric: lining-nums tabular-nums;

	> .paren-gutter {
		visibility: hidden;
	}
`;

export const HoldingsCardStyles = styled.div`
	.mantine-table-scroll-area {
		border-top: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-top-left-radius: 0.25rem;
		border-top-right-radius: 0.25rem;
	}
`;

export const HoldingsCardActionsStyles = styled.div`
	.fullscreen,
	.columns {
		width: 2.375rem !important;
		height: 2.375rem !important;
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-radius: 0.25rem;
		padding: 0.5rem !important;
	}

	.fullscreen {
		svg {
			color: ${({ theme }) => theme.v3.colors.black[0]};
		}
	}

	.columns {
		color: ${({ theme }) => theme.v3.colors.dark[8]};

		&:hover {
			color: inherit;
			background-color: inherit;
		}
	}
`;
